import * as HLF from "html-living-framework";
import * as Topics from "../Data/Topics";
import { KeyboardFocus } from "../GameObjects/KeyboardFocus";

export class KeyboardFocusManager extends PIXI.Container {
    private _activeFoci: KeyboardFocus[];
    private _focusPool: KeyboardFocus[];
    private _pubSubTokens: any[];

    constructor() {
        super();

        this._pubSubTokens = new Array<any>();
        this._focusPool = new Array<KeyboardFocus>();
        this._activeFoci = new Array<KeyboardFocus>();

        this._pubSubTokens.push(PubSub.subscribe(Topics.KEYBOARD_FOCUS_BEGIN, this.onFocusBegin.bind(this)));
        this._pubSubTokens.push(PubSub.subscribe(Topics.KEYBOARD_FOCUS_END, this.onFocusEnd.bind(this)));
        this._pubSubTokens.push(PubSub.subscribe(Topics.KEYBOARD_REFOCUS, this.reFocus.bind(this)));
    }

    public destroy(pOptions?: boolean | PIXI.DestroyOptions): void {
        for (let i = 0; i < this._pubSubTokens.length; ++i) {
            PubSub.unsubscribe(this._pubSubTokens[i]);
        }
        super.destroy(pOptions);
    }

    private onFocusBegin(pTopic: string, pFocusable: HLF.Input.IFocusable): void {
        const focus: KeyboardFocus = this.getFocus();
        this.addChild(focus);
        focus.show(pFocusable);
        this._activeFoci.push(focus);
    }

    private onFocusEnd(pTopic: string, pFocusable: HLF.Input.IFocusable): void {
        for (let i = 0; i < this._activeFoci.length; ++i) {
            if (this._activeFoci[i].target === pFocusable) {
                const focus: KeyboardFocus = this._activeFoci[i];
                focus.hide(() => {
                    this.removeChild(focus);
                    this._activeFoci.splice(this._activeFoci.indexOf(focus), 1);
                    this._focusPool.push(focus);
                });
            }
        }
    }

    private reFocus(): void {
        if (this._activeFoci.length > 0) {
            const focus: KeyboardFocus = this._activeFoci[this._activeFoci.length - 1];
            focus.fitToTarget();
        }
    }

    private getFocus(): KeyboardFocus {
        let focus: KeyboardFocus;
        if (this._focusPool.length > 0) {
            focus = this._focusPool.pop()!;
        }
        else {
            focus = new KeyboardFocus();
        }
        return focus;
    }
}
